import React from 'react';
import clsx from 'clsx';

import { textToColor } from '../../utilities';

type BadgeProps = {
  text: string;
  shrink?: boolean;

  rounded?: boolean;
  textClassName?: string;
};

const Badge: React.FC<BadgeProps> = ({
  text = '',
  shrink,
  rounded,
  textClassName = 'font-bold',
}) => {
  const content = (shrink ? text?.[0] || '' : text).toLocaleUpperCase();
  const background = textToColor(text || '');

  return (
    <span
      className={clsx(
        textClassName,
        rounded ? 'w-full h-full rounded-full' : 'size-[2.4rem] rounded-xs',
        'grow-0 shrink-0 flex items-center justify-center text-small'
      )}
      style={{ background }}
    >
      {content}
    </span>
  );
};

export default React.memo(Badge) as typeof Badge;
